import { useEffect, useState } from 'react';

interface IWindowDimensions {
  width: number;
  height: number;
}

export const useWindowDimensions = () => {
  const [dimensions, setDimensions] = useState<IWindowDimensions>({
    width: window.innerWidth || 0,
    height: window.innerHeight || 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return dimensions;
};
